import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { importSources } from "../lib/api";
import { ConnectorCard, GoogleCard, SHOW_GOOGLE } from "./ImportView";

// "Connect CRM" on the Contacts page: sign in to Google, Zoho, HubSpot, Pipedrive or Salesforce, and pull contacts in.
export default function ConnectCrmModal({ close, onImported, onOpenImport }) {
  const [sources, setSources] = useState(null);
  useEffect(() => { importSources().then(setSources).catch(() => { toast.error("Couldn't load the connect options"); close(); });   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="modal-backdrop" onClick={close}>
    <div className="modal login-card setup-card" onClick={e => e.stopPropagation()} data-testid="connect-crm-modal">
      <button className="modal-close" onClick={close}><X size={16} /></button>
      <h2>Connect CRM</h2>
      <p>Link an account and its contacts come straight into this list. Nobody appears twice, and re-connecting only fills in blanks.</p>
      {!sources ? <p className="muted">Loading…</p> : <>
        {SHOW_GOOGLE && <GoogleCard google={sources.google} onImported={onImported} />}
        {sources.connectors.map(c => <ConnectorCard key={c.key} c={c} onImported={onImported} />)}
        <small className="muted">Any other CRM or a spreadsheet: <button className="link-button" onClick={() => { close(); onOpenImport(); }}>import a file instead</button>.</small>
      </>}
    </div>
  </div>;
}
